<div class="tap-top" (click)="tapToTop()" [class]="show ? 'flex' : 'none'">
  <app-feather-icons class="d-flex" [icon]="'chevrons-up'"></app-feather-icons>
</div>
